const settings = process.env;
export const poolData = {
  Auth: {
    region: settings.REACT_APP_COGNITO_REGION,
    userPoolId: settings.REACT_APP_COGNITO_USER_POOL,
    userPoolWebClientId: settings.REACT_APP_CLIENT_ID,
    identityPoolId: settings.REACT_APP_IDENTITY_POOL_ID,
  },
};
